import React from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '@components/PrimaryButton';
import ArrowRight from '@components/Icons/ArrowRight';
import { useStyles, useStylesButton } from './styles';

const BottomRecommendBanner = ({ isDisplayBottomBanner }) => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const history = useHistory();

  const goToRecommendPage = () => {
    history.push('/slider-screen', { from: '/menu' });
  };

  return (
    <div
      className={classes.stickyBannerWrapper}
      onClick={goToRecommendPage}
      style={{
        transform: isDisplayBottomBanner
          ? 'translateY(0px)'
          : 'translateY(100px)',
      }}
    >
      <div className={classes.banner}>
        <div className={classes.textPart}>Too much choice? Get advice</div>
        <PrimaryButton
          text={<ArrowRight />}
          handleClick={goToRecommendPage}
          classesButton={classesButton}
        />
      </div>
    </div>
  );
};

export default BottomRecommendBanner;
